import PropTypes from "prop-types";
import AlertMessage from "app/pages/.shared/AlertMessage";
import { ALERT_TYPE } from "app/constants";
import { FormattedMessage } from "react-intl";

const USAWarningMessage = ({ showWarning }) => {
	if (!showWarning) {
		return null;
	}

	return (
		<AlertMessage
			alertType={ALERT_TYPE.INFO}
			className="warning-usa-destination"
			message={<FormattedMessage id="general.warning.adult.destination.usa" />}
		/>
	);
};

USAWarningMessage.propTypes = {
	showWarning: PropTypes.bool.isRequired,
};

export default USAWarningMessage;
